<div class="detail-body">
    <div class="detail-documents relevant-info">
        <h2>
            <span class="material-symbols-outlined hashtag"> tag </span>
            {{ 'REQUEST_DETAIL.DOCUMENTS_ANALYZED' | translate }}
        </h2>
        <div class="detail-content">
            <div class="detail-content-header">
                <span class="material-symbols-outlined custom-doc "> description </span>
                <h3>{{ 'REQUEST_DETAIL.ENRICHMENT' | translate }}</h3>

                <div class="accordion-buttons">
                    <!-- EXPAND ALL BUTTON -->
                    <p-button
                        *ngIf="cardRequestDetailDocumentsService.enrichmentAccordion.length > 0 && cardRequestDetailDocumentsService.activedAccordionItems.length !== cardRequestDetailDocumentsService.enrichmentAccordion.length"
                        [disabled]="cardRequestDetailDocumentsService.activedAccordionItems.length === cardRequestDetailDocumentsService.enrichmentAccordion.length"
                        (click)="cardRequestDetailDocumentsService.expandAll()"
                        pTooltip="{{ 'REQUEST_DETAIL.EXPAND_ALL' | translate }}" tooltipPosition="top"
                        styleClass="p-button-rounded p-button-secondary p-button-text">
                        <span class="material-symbols-outlined"> keyboard_arrow_down </span>
                    </p-button>

                    <!-- COLLAPSE ALL BUTTON -->
                    <p-button
                        *ngIf="cardRequestDetailDocumentsService.enrichmentAccordion.length > 0 && cardRequestDetailDocumentsService.activedAccordionItems.length !== 0"
                        [disabled]="cardRequestDetailDocumentsService.activedAccordionItems.length === 0"
                        (click)="cardRequestDetailDocumentsService.colapseAll()"
                        pTooltip="{{ 'REQUEST_DETAIL.COLLAPSE_ALL' | translate }}" tooltipPosition="top"
                        styleClass="p-button-rounded p-button-secondary p-button-text">
                        <span class="material-symbols-outlined"> keyboard_arrow_up </span>
                    </p-button>
                </div>
            </div>
            <div class="">
                <!-- <p class="detail-item-name">{{enrichment.title}}</p> -->
                <p-accordion [multiple]="true" [(value)]="this.cardRequestDetailDocumentsService.activedAccordionItems">
                    <p-accordion-panel
                        *ngFor="let enrichment of this.cardRequestDetailDocumentsService.enrichmentAccordion; let i = index"
                        [value]="i"
                        (onOpen)="this.cardRequestDetailDocumentsService.onTabOpen(i)"
                        (onClose)="this.cardRequestDetailDocumentsService.onTabClose(i)"
                    >
                        <p-accordion-header>
                            {{ enrichment.title | translate }}
                        </p-accordion-header>
                        <p-accordion-content>
                        <table>
                            <thead>
                                <th>{{ 'REQUEST_DETAIL.KEY' | translate }}</th>
                                <th>{{ 'REQUEST_DETAIL.VALUE' | translate }}</th>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let e of enrichment.elements">
                                    @if(feasibilityKeys.includes(e.key)){
                                        <tr>
                                            <td>{{ translateFeasibilityKey(e.key) }}</td>
                                            @if(isNumber(e.value)){
                                                <td class="W200">{{ +e.value | number:'1.0-2':'es-ES' }}</td>
                                            }@else{
                                                <td class="W200">{{ translateIfBoolean(e.value) }}</td>
                                            }
                                        </tr>
                                    }@else{
                                        <tr>
                                            <td>{{ e.key }}</td>
                                            @if(isNumber(e.value)){
                                                <td class="W200">{{ +e.value | number:'1.0-2':'es-ES' }}</td>
                                            }@else {
                                                <td class="W200">{{ e.value }}</td>
                                            }
                                        </tr>
                                    }
                                </ng-container>
                            </tbody>
                        </table>
                        </p-accordion-content>
                    </p-accordion-panel>
                </p-accordion>
            </div>
        </div>
    </div>

    <app-detail-documents class="detail-documents" headerLabel="REQUEST_DETAIL.REQUEST_RECEIVED_DOCUMENTS" contentLabel="REQUEST_DETAIL.TAX_DOCUMENTATION" [detail]="cardRequestDetailService.request" [toRemove]="documentNamesToRemove" />
</div>
